module.exports = __webpack_public_path__ + "img/ic_revenue.c8fb4ebe.png";